export type ElComponentStatus = 'primary' | 'success' | 'warning' | 'danger' | 'info';
